<template>
  <div>
    <TheSystem system-name="As per COA" />
  </div>
</template>
<script>
// @ is an alias to /src
import TheSystem from "@/components/System.vue";

export default {
  name: "AsPerCOA",
  components: {
    TheSystem,
  },
  metaInfo: {
    title: "As per COA - Master of Technology - Part Time",
    htmlAttrs: {
      lang: "en-US",
    },
    meta: [
      { charset: "utf-8" },
      { content: "1 days", name: "revisit-after" },
      { content: "100012765211323", property: "fb:admins" },
      { content: "Aditya Jain", name: "Author" },
      {
        content:
          "Aeiwi, Alexa, AllTheWeb, AltaVista, AOL Netfind, Anzwers, Canada, DirectHit, EuroSeek, Excite, Overture, Go, Google, HotBot. InfoMak, Kanoodle, Lycos, MasterSite, National Directory, Northern Light, SearchIt, SimpleSearch, WebsMostLinked, WebTop, What-U-Seek, AOL, Yahoo, WebCrawler, Infoseek, Excite, Magellan, LookSmart, CNET, Googlebot",
        name: "search engines",
      },
      {
        content:
          "Master of Technology - Part Time - As per COA. Get RGPV latest PDF downloadable notes free.Rgpv ebooks, video lectures and all the study material for all the semesters of the Rgpv university.",
      },
      { content: "India", name: "geo.placename" },
      { content: "RGPV Notes", name: "twitter:title" },
      { content: "RGPV Notes", property: "og:site_name" },
      { content: "RGPV Notes", property: "og:site_name" },
      { content: "RGPV Notes", property: "og:title" },
      {
        content:
          "RGPV latest CBCS CBGS AICTE scheme PDF downloadable notes all unit free superfast server.Master of Technology - Part Time - As per COA",
        name: "description",
      },
      {
        content:
          "RGPV latest CBCS CBGS AICTE scheme PDF downloadable notes all unit free superfast server.Master of Technology - Part Time - As per COA",
        name: "og:description",
      },
      {
        content:
          "RGPV latest CBCS CBGS AICTE scheme PDF downloadable notes all unit free superfast server.Master of Technology - Part Time - As per COA",
        name: "twitter:card",
      },
      {
        content:
          "RGPV latest CBCS CBGS AICTE scheme PDF downloadable notes all unit free superfast server.Master of Technology - Part Time - As per COA",
        name: "twitter:description",
      },
      {
        content:
          "RGPV latest CBCS CBGS AICTE scheme PDF downloadable notes all unit free superfast server.Master of Technology - Part Time - As per COA",
        property: "og:description",
      },
      { content: "all", name: "audience" },
      { content: "general", name: "rating" },
      {
        content:
          "https://cdn.rgpvnotes.in/M.Tech (Part Time)/main/og%20banner%20image.png",
        property: "og:image",
      },
      { content: "https://www.aadityajain.dev/", property: "article:author" },
      { content: "https://www.rgpvnotes.in/", name: "twitter:domain" },
      { content: "https://www.rgpvnotes.in/", property: "og:url" },
      { content: "id", name: "geo.country" },
      { content: "id_id", property: "og:locale" },
      { content: "site", name: "generator" },
      { content: "text/html; charset=UTF-8", "http-equiv": "Content-Type" },
      { content: "translate", name: "google" },
      { content: "website", property: "og:type" },
    ],
    link: [
      { content: "https://www.rgpvnotes.in/", rel: "pingback" },
      {
        href: "https://cdn.rgpvnotes.in/M.Tech (Part Time)/main/favicon.ico",
        rel: "icon",
        type: "image/x-icon",
      },
      { href: "https://www.aadityajain.dev/", rel: "me" },
      { href: "https://www.aadityajain.dev/", rel: "author" },
      { href: "https://www.aadityajain.dev/", rel: "publisher" },
      { href: "https://www.rgpvnotes.in/", rel: "canonical" },
      { href: "https:/www.rgpvnotes.in/", rel: "openid.delegate" },
      {
        href: "https://cdn.rgpvnotes.in/M.Tech (Part Time)/main/favicon.ico",
        rel: "apple-touch-icon",
      },
    ],
  },
};
</script>
